import {isPresentationRecord} from "@repo/ui/gailgpt/tool-presentation";

/** Tool transports may wrap the same frozen request in a body field. */
export function toolRequestBody(parameters: Record<string, unknown>): Record<string, unknown> {
   return isPresentationRecord(parameters.body) ? parameters.body : parameters;
}
